"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStyles = void 0;
var getStyles = function (props) {
    return {
        root: {
            padding: 2,
            outline: 'none',
        },
        tableCell: {
            padding: 0,
        },
    };
};
exports.getStyles = getStyles;
//# sourceMappingURL=ButtonGrid.styles.js.map